let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("46n7v")).then(() => parcelRequire('kbmIh'));